module.exports = __webpack_public_path__ + "static/setup-wizard-19be6a7f4521811996b8128a09b1a172.svg";